import React, { ReactNode } from 'react';
import { BasePopover } from '@/components/uiKit/Popover';
import { HEALTH_STATUS } from '@/const';
import { HealthStatusIndicator } from '@/components/shared/display/StateIndicator';

const LegendContent = () => {
  return (
    <div className="z-20">
      <div className="font-semibold mb-5">Health Trend Legend</div>
      <div className="flex flex-col gap-4">
        <HealthStatusIndicator type={HEALTH_STATUS.CRITICAL} showDescription />
        <HealthStatusIndicator type={HEALTH_STATUS.ALARM} showDescription />
        <HealthStatusIndicator type={HEALTH_STATUS.MONITOR} showDescription />
        <HealthStatusIndicator type={HEALTH_STATUS.HEALTHY} showDescription />
        <HealthStatusIndicator type={HEALTH_STATUS.NOT_AVAILABLE} showDescription />
      </div>
    </div>
  );
};

interface LegendPopoverProps {
  children: ReactNode;
  onActiveChange: (isOpen: boolean) => void;
}

export const LegendPopover = ({ children, onActiveChange }: LegendPopoverProps) => {
  const popoverProps = {
    side: 'right',
    sideOffset: 20,
    align: 'start',
    alignOffset: -65,
  };

  return (
    <BasePopover
      content={<LegendContent />}
      onOpenChange={onActiveChange}
      closeButtonSize="lg"
      className="w-[var(--legend-popover-width)] p-6"
      {...popoverProps}
    >
      {children}
    </BasePopover>
  );
};
